/**
 * Clase que representa al cliente/neavegador en cuestión.
 */
class Client {
    /* STATIC */
    private static LS_PREMIUM_KEY       = 'mr-user-premium';
    private static LS_WEB_PREMIUM_KEY   = 'token';

    /* INSTANCE */

    public constructor() {
    }

    public get premium(): boolean {
        if (window.localStorage) {
            const appPremium = window.localStorage.getItem(Client.LS_PREMIUM_KEY);
            const webPremium = window.localStorage.getItem(Client.LS_WEB_PREMIUM_KEY);

            return appPremium === '1' || (webPremium !== undefined && webPremium !== null);
        }
        return false;
    }
}

let instance: Client|null = null;
export default () => instance ??= new Client();
